<!--在线用户-->
<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :wrapperClosable="false"
    title="在线用户明细"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    append-to-body
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">在线用户明细</span>
    </div>
    <div class="form_content" style="padding: 10px 20px">
      <div ref="tablePanel" class="fullheight">
        <div class="top_search">
          <el-row style="height: 100%; width: 100%">
            <el-col :span="6" class="col_style">
              <el-input v-model="code"> </el-input>
            </el-col>
            <el-col :span="6" class="col_style">
              <el-button type="primary" @click="loadData()">搜索</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="table_content">
          <el-table
            ref="ecoTable"
            :style="{
              height: `${tableMaxHeight}` + 'px'
            }"
            :max-height="tableMaxHeight"
            :data="templateData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="headerCellStyle"
          >
            <el-table-column type="index" label="序号" width="55"> </el-table-column>
            <el-table-column prop="fullname" label="用户名称"> </el-table-column>
            <el-table-column prop="loginDate" label="登录时间">
              <template slot-scope="scope">
                {{ $utils.formatDate(scope.row.loginDate) }}
              </template>
            </el-table-column>
            <el-table-column prop="expiration" label="过期时间">
              <template slot-scope="scope">
                {{ $utils.formatDate(scope.row.expiration) }}
              </template>
            </el-table-column>
            <el-table-column prop="deviceType" label="系统类型">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.deviceType === 'IEZU-EVO-FRONT'" type="success">前台</el-tag>
                <el-tag v-if="scope.row.deviceType === 'IEZU-EVO-PLATFORM'" type="success">后台</el-tag>
                <el-tag v-if="scope.row.deviceType === 'IEZU-EVO-APP'" type="success">APP</el-tag>
                <el-tag v-if="scope.row.deviceType === 'IEZU-EVO-H5'" type="success">H5</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="logout(scope.row)">下线</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import uc from '@/api/uc'
import $utils from '../../../utils'
import { Message } from 'element-ui'
export default {
  name: 'onlineUserRecordDialog',
  computed: {
    $utils() {
      return $utils
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    tempValue: {
      type: Object,
      default: () => {}
    },
    tenantId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      drawerSize: '70%',
      boDefIdList: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      tableMaxHeight: document.body.clientHeight - 200,
      activeName: 'first',
      code: ''
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  methods: {
    beforeCloseDialog() {
      this.$emit('closeOnlineUserRecord')
    },
    submit() {},
    //表头样式
    headerCellStyle() {
      return {
        textAlign: 'center',
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    //初始化加载
    loadData() {
      uc.getOnlineUser(this.tenantId, this.currentPage, this.pageSize, this.code).then((resp) => {
        this.templateData = resp.data
        console.info(resp.count)
        this.total = Number(resp.count)
      })
    },
    logout(row) {
      uc.logout(row.tokenValue)
        .then((resp) => {
          if (resp.state) {
            Message.success('成功下线账号[' + row.fullname + ']')
          } else {
            Message.error('下线账号失败')
          }
        })
        .catch(() => {
          Message.error('下线账号失败')
        })
        .finally(() => {
          this.loadData()
        })
    }
  }
}
</script>

<style scoped>
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
